import * as Yup from "yup";
import { commonPassword, password } from "../YupSchema";

export const ValidationRecovery = Yup.object().shape({
  old_password: commonPassword,
  new_password: password,
  second_new_password: Yup.string()
    .required("global.schemas.secondPassword.required")
    .oneOf([Yup.ref("new_password")], "global.schemas.secondPassword.oneOf"),
});
